<script>
export const tags = ['div', 'section'];

export default {
  props: {
    as: {
      type: String,
      default: 'div',
      validator: (value) => tags.includes(value),
    },
  },
  render(create) {
    return create(this.as, { class: 'hero' }, this.$slots.default);
  },
};
</script>

<style lang="scss" scoped>
$height: 100vh;

.hero {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  min-height: 100vh;

  // webkit on mobile need this hack to properly show full height (100vh - menu_height)
  // TODO refactor this media-query to min-width if we decide to go with only min-widths
  @media screen and (max-width: $screen-tablet - 1) and (orientation: portrait) {
    @supports (-webkit-appearance: none) {
      // TODO min-height should be tested on many mobile devices when this branch gets deployed
      min-height: calc(100vh - 56px);
    }
  }

  @include ie {
    height: $height;
  }
}
</style>
